export default "/_next/static/chunks/fonts/S6uyw4BMUTPHjx4wXg-65e877e527022735c1a1bf5ae6183cf6.woff2";